import { useEffect, useState } from "react";

type Listener = (visible: boolean) => void;

let windowVisible = false;
const listeners = new Set<Listener>();

/** Called from `FrontChat` when Front reports open/close via its SDK. */
export function setFrontChatWindowVisible(visible: boolean): void {
  if (windowVisible === visible) {
    return;
  }
  windowVisible = visible;
  for (const listener of listeners) {
    listener(visible);
  }
}

/**
 * Whether Front's messenger panel is open. The Scout launcher drops below
 * Front's iframe (z-index 1201) while this is true so the two widgets do
 * not stack on top of each other.
 */
export function useFrontChatWindowVisible(): boolean {
  const [visible, setVisible] = useState(windowVisible);

  useEffect(() => {
    listeners.add(setVisible);
    return () => {
      listeners.delete(setVisible);
    };
  }, []);

  return visible;
}
